import { render, staticRenderFns } from "./tooltip_on_truncate.vue?vue&type=template&id=0f120041&"
import script from "./tooltip_on_truncate.vue?vue&type=script&lang=js&"
export * from "./tooltip_on_truncate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tooltip_on_truncate.vue"
export default component.exports